import { createFileRoute } from "@tanstack/react-router";
import TarifasPage from "@/pages/TarifasPage";
import { landingHead } from "@/lib/landingHead";
import { pricingJsonLd } from "@/lib/pricingJsonLd";

export const Route = createFileRoute("/en/pricing")({
  head: () => ({
    ...landingHead("pricing", "en"),
    scripts: [{ type: "application/ld+json", children: JSON.stringify(pricingJsonLd("en")) }],
  }),
  component: () => <TarifasPage routeLang="en" />,
  errorComponent: () => <TarifasPage routeLang="en" />,
  notFoundComponent: () => <TarifasPage routeLang="en" />,
});
